import { FC } from "react";
import CLTVDashboard from "../CLTVDashboard";
import "./CLTVAnalysisDashboard.scss";

const CLTVAnalysisDashboard: FC = () => {
  return (
    <div className="cltv-analysis-dashboard">
      <CLTVDashboard />
    </div>
  );
};

export default CLTVAnalysisDashboard;
